import { Box, Typography } from "@mui/material";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";

const CustomTabList = ({ tabs = [], onChange }) => {
  return (
      <Box sx={{ flex:"wrap", backgroundColor:"#fff", height:"56px", paddingTop:"8px", display: "inline-flex", borderRadius:"30px", maxWidth: "100%", overflowX: "auto" }}>
          <TabList aria-label="custom tabs" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ '& .MuiTab-root': { minHeight:"unset", width:"auto !important", borderRadius:"10px !important", backgroundColor: '#f2f2f2', color: '#707070', margin: '0 4px !important', '&.Mui-selected': { color: '#fff !important', backgroundColor:"#032541 !important" }}, '& .MuiTabs-indicator': { display:"none" }, '& .MuiTabs-scrollButtons': { color: '#032541' }}} onChange={onChange}>
           {tabs.map((tab) => (
            <Tab sx={{ textTransform:"none", textWrap:"nowrap"}} key={tab.value} 
              label={  
                <Box sx={{ display:"flex", gap:"4px", alignItems:"center", justifyContent:"center"}}>
                  <Typography sx={{fontSize:'14px', fontWeight:"500" }}>{tab.label}</Typography>
                  { tab.count && <Typography sx={{ fontSize:"14px", fontWeight:"500" }}>({tab.count || 0})</Typography> }
                </Box> 
              }  
              value={tab.value} 
              className="tab"
            />
          ))}
        </TabList>
      </Box>
  );
};

export default CustomTabList;